import { render, staticRenderFns } from "./TabelaCoparticipacao.vue?vue&type=template&id=92d2bd88&scoped=true&"
import script from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCoparticipacao.vue?vue&type=style&index=0&id=92d2bd88&scoped=true&lang=css&"
import style1 from "./TabelaCoparticipacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d2bd88",
  null
  
)

export default component.exports